export const vnsSettingColumns = (columnFilter?: (column: string) => boolean) =>
  ['normalMode', 'autoStimMode', 'magnetMode', 'initialization'].filter(columnFilter ?? (column => column));

export const vnsSettingRows = (rowFilter?: (row: string) => boolean) =>
  ['outputCurrent', 'rate', 'pulseWidth', 'onTime', 'offTime', 'efficiencyCycle', 'autoStimThreshold'].filter(
    rowFilter ?? (row => row),
  );
